import { createStore } from 'satcheljs';
export default createStore('categoriesOption', {
    newCategory: {},
})();
//# sourceMappingURL=store.js.map